<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid role-page-container"
    >
      <div class="role-form-container">
        <div>
          <div *ngIf="isLoading" class="loading-container">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
            <p class="mt-3 text-muted">{{ "loadingData" | translate }}...</p>
          </div>

          <div *ngIf="!isLoading">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <h3 class="card-label fw-bold fs-3 mb-1">
                  {{
                    (mode === "edit"
                      ? "roleList.editRole"
                      : "roleList.createRole"
                    ) | translate
                  }}
                </h3>
              </div>

              <div class="d-flex align-items-center gap-3">
                <button
                  class="btn btn-sm fw-bold btn-primary"
                  (click)="saveRole()"
                  [disabled]="!isFormValid()"
                >
                  <i class="fa-solid fa-save me-2"></i>
                  {{ "save" | translate }}
                </button>
              </div>
            </div>

            <div class="config-card mb-4 mt-4">
              <div class="config-card-body">
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label">
                        <i class="fa-solid fa-tag"></i>
                        {{ "roleList.roleName" | translate }}
                        <span class="required"></span>
                      </label>
                      <input
                        [(ngModel)]="roleName"
                        type="text"
                        class="form-control"
                        [placeholder]="'roleList.enterRoleName' | translate"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    *ngIf="
                      mode === 'create' &&
                      !currentUser?.userOrganizations?.length
                    "
                  >
                    <div class="form-group">
                      <label class="form-label">
                        <i class="fa-solid fa-building"></i>
                        {{ "ORGANIZATION" | translate }}
                        <span class="required"></span>
                      </label>
                      <app-select
                        [(ngModel)]="selectedOrganizationId"
                        [items]="organizations"
                        bindLabel="name"
                        bindValue="id"
                        [clearable]="true"
                        name="organizationSelect"
                        (change)="orgSelectTouched = true"
                        (click)="orgSelectTouched = true"
                        appendTo="body"
                        [placeholder]="'ORGANIZATION' | translate"
                      >
                      </app-select>
                      <div
                        class="text-danger fs-12 mt-1"
                        *ngIf="
                          !selectedOrganizationId &&
                          (orgSelectTouched || isSaving)
                        "
                      >
                        {{ "patientCreate.validation.required" | translate }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="role-types-section mt-4">
                  <div class="role-types-grid">
                    <div
                      class="role-type-card"
                      *ngFor="let type of roleTypes"
                      [class.selected]="type.isSelected"
                      [class.disabled]="isRoleTypeDisabled(type)"
                      (click)="
                        toggleRoleType(type, {
                          target: { checked: !type.isSelected },
                        })
                      "
                    >
                      <input
                        class="role-type-input"
                        type="radio"
                        [id]="'type_' + type.value"
                        [name]="'roleType'"
                        [checked]="type.isSelected"
                        (click)="$event.stopPropagation()"
                      />
                      <div class="role-type-content">
                        <div class="role-type-icon">
                          <i class="fa-solid fa-user-shield"></i>
                        </div>
                        <span class="role-type-label">{{ type.label }}</span>
                        <div class="role-type-check">
                          <i class="fa-solid fa-check"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="permissions-section">
              <div class="section-header mb-4">
                <div class="section-header-content">
                  <i class="fa-solid fa-shield-halved"></i>
                  <div>
                    <h2 class="section-title">
                      {{ "roleList.permissions" | translate }}
                    </h2>
                    <p class="section-description">
                      {{ "roleList.selectPermissions" | translate }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="services-grid">
                <div
                  class="service-card"
                  *ngFor="let service of serviceGroups; let i = index"
                  [style.animation-delay]="i * 50 + 'ms'"
                >
                  <div
                    class="service-card-header"
                    (click)="toggleServiceAccordion(service)"
                  >
                    <div class="service-header-left">
                      <div class="service-icon">
                        <i class="fa-solid fa-cube"></i>
                      </div>
                      <div class="service-info">
                        <h3 class="service-name">{{ service.serviceName }}</h3>
                        <span class="service-stats">
                          <span class="stats-selected">{{
                            getSelectedPermissionCount(service)
                          }}</span>
                          <span class="stats-separator">/</span>
                          <span class="stats-total">{{
                            getTotalPermissionCount(service)
                          }}</span>
                          <span class="stats-label">{{
                            "permissions" | translate
                          }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="service-header-right">
                      <div
                        class="select-all-toggle"
                        (click)="$event.stopPropagation()"
                      >
                        <label class="toggle-switch">
                          <input
                            type="checkbox"
                            (change)="toggleService(service, $event)"
                            [checked]="isServiceFullySelected(service)"
                            [disabled]="isServiceDisabled(service)"
                          />
                          <span class="toggle-slider"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="service-card-body"
                    [class.expanded]="service.isExpanded"
                  >
                    <div class="service-content">
                      <div
                        class="subgroup-item"
                        *ngFor="let subGroup of service.subGroups"
                      >
                        <div
                          class="subgroup-header"
                          (click)="toggleSubGroupAccordion(subGroup)"
                        >
                          <div class="subgroup-header-left">
                            <i
                              class="fa-solid"
                              [class.fa-folder]="!subGroup.isExpanded"
                              [class.fa-folder-open]="subGroup.isExpanded"
                            ></i>
                            <span class="subgroup-name">{{
                              subGroup.groupName
                            }}</span>
                            <span class="subgroup-count"
                              >({{ subGroup.permissions.length }})</span
                            >
                          </div>
                          <div
                            class="subgroup-header-right"
                            (click)="$event.stopPropagation()"
                          >
                            <label
                              class="toggle-switch-sm"
                              (click)="$event.stopPropagation()"
                            >
                              <input
                                type="checkbox"
                                (change)="toggleSubGroup(subGroup, $event)"
                                [checked]="isSubGroupFullySelected(subGroup)"
                                [disabled]="isSubGroupDisabled(subGroup)"
                              />
                              <span class="toggle-slider-sm"></span>
                            </label>
                            <i
                              class="fa-solid fa-chevron-down subgroup-chevron"
                              [class.rotated]="subGroup.isExpanded"
                              (click)="toggleSubGroupAccordion(subGroup); $event.stopPropagation()"
                            ></i>
                          </div>
                        </div>

                        <div
                          class="subgroup-permissions"
                          [class.expanded]="subGroup.isExpanded"
                        >
                          <div class="permissions-list">
                            <label
                              class="permission-item"
                              *ngFor="let perm of subGroup.permissions"
                              [class.disabled]="perm.isDisabled"
                            >
                              <input
                                type="checkbox"
                                class="permission-checkbox"
                                [id]="'perm_' + perm.key"
                                [(ngModel)]="perm.isSelected"
                                [disabled]="perm.isDisabled"
                              />
                              <span class="permission-checkmark">
                                <i class="fa-solid fa-check"></i>
                              </span>
                              <div class="permission-content">
                                <span class="permission-label">{{
                                  perm.label
                                }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="serviceGroups.length === 0" class="empty-state">
              <i class="fa-solid fa-inbox"></i>
              <h3>{{ "noPermissionsAvailable" | translate }}</h3>
              <p>{{ "pleaseSelectRoleType" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
